// extracted by mini-css-extract-plugin
var _1 = "ClientNoteAuthor_container__1W9h5";
var _2 = "ClientNoteAuthor_date__O7W7y";
var _3 = "ClientNoteAuthor_name__0yegR";
var _4 = "ClientNoteAuthor_text__Fio42";
export { _1 as "container", _2 as "date", _3 as "name", _4 as "text" }
